import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Membaca `activeSession.permissions` (diisi back-end lewat
 * GetAuthenticationSessionUseCase, lihat plan RBAC Fase B2) dan menyediakan
 * helper `can`/`canAny`/`canAll`.
 *
 * FAIL-CLOSED secara sengaja: kalau `permissions` kosong/absen (mis. user
 * mentor/student yang memang tidak punya RBAC, atau data belum termuat),
 * `can()` mengembalikan false -- kebalikan dari flag lama `hasFullAccess`
 * yang fail-OPEN saat scope kosong.
 */
export default function usePermission() {
  const { authUser } = useAuth();

  const permissions = useMemo(
    () => new Set(authUser?.activeSession?.permissions || []),
    [authUser],
  );

  const can = (code) => permissions.has(code);
  const canAny = (codes) => codes.some((code) => permissions.has(code));
  const canAll = (codes) => codes.every((code) => permissions.has(code));

  return {
    permissions, can, canAny, canAll,
  };
}
